import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'

export const useBookingsEmailReminderMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: bookingsEmailReminderMutation } = useMutation({
		mutationFn: (ids: (number | null)[]) => {
			return axiosPrivate.post(apiRoutes.bookingsEmailReminder, { ids })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Email reminder request succeeded')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		bookingsEmailReminderMutation
	}
}
